<div class="related-videos__container o-flex o-flex--column" *ngIf="relatedVideoList">
  <p class="related-videos__heading u-font-weight-700">{{title}}</p>
  <div class="related-videos__video-content o-flex o-flex--justify-space-between">
          <iframe class="u-margin-5" *ngFor="let video of relatedVideoList" width="340" height="250" src="https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/recovery_index/Recovery Index - Trailer.mp4" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
  </div>
</div>
